import account from './account';
import app from './app';
import authentication from './authentication';
import dragDrop from './dragDrop';
import modals from './modals';
import people from './people';
import popup from './popup';
import lead from './lead';
import sidebar from './sidebar';
import leadDetail from './leadDetail';

export default {
  app,
  authentication,
  popup,
  modals,
  account,
  dragDrop,
  people,
  lead,
  sidebar,
  leadDetail
};
